export default function invert(object) {
    let newObj = {};
    for ( var key in object ) {
        newObj[object[key]] = key;
    }
    return newObj;
}